import Vue from 'vue'

// TODO Migration Vue3 : remove Vue.set
export const useReactiveSet = (object: object, index: string | number, value: unknown) => Vue.set(object, index, value)
